import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=3a5cf452&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=3a5cf452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5cf452",
  null
  
)

export default component.exports